import { useEffect, useRef } from 'react';
import socket from 'socket';

const CANVAS_BOARD_UPDATED = 'CANVAS_BOARD_UPDATED';

function matchesBoard(payload, { personName, hashtag }) {
  if (!payload?.personName || !payload?.canvasNames?.length) return false;

  const personMatch =
    String(payload.personName).toLowerCase() === String(personName || '').toLowerCase();
  if (!personMatch) return false;

  return payload.canvasNames.some(
    name => String(name).toLowerCase() === String(hashtag || '').toLowerCase()
  );
}

/**
 * Subscribe to real-time canvas board updates via Socket.IO.
 * Server emits to the authenticated user's room; Redis adapter fans out in production.
 */
export function useCanvasBoardSocket({ enabled = true, personName, hashtag, onBoardUpdated }) {
  const onBoardUpdatedRef = useRef(onBoardUpdated);
  onBoardUpdatedRef.current = onBoardUpdated;

  useEffect(() => {
    if (!enabled || !personName || !hashtag) return undefined;

    const handleBoardUpdated = payload => {
      if (!matchesBoard(payload, { personName, hashtag })) return;
      onBoardUpdatedRef.current?.(payload);
    };

    socket.on(CANVAS_BOARD_UPDATED, handleBoardUpdated);
    if (!socket.connected) socket.connect();

    return () => {
      socket.off(CANVAS_BOARD_UPDATED, handleBoardUpdated);
    };
  }, [enabled, personName, hashtag]);
}

export { CANVAS_BOARD_UPDATED, matchesBoard };
